(() => {
  const WEEK_MS = 7 * 24 * 60 * 60 * 1000;
  const HOUR_MS = 60 * 60 * 1000;
  const KUWAIT_TIME_ZONE = 'Asia/Kuwait';
  const pad = (value) => String(value).padStart(2, '0');

  const resolveEventWindow = (anchor, schedule, durationMs, now) => {
    if (schedule !== 'weekly') {
      return { start: anchor, end: anchor + durationMs, live: now >= anchor && now < anchor + durationMs };
    }

    if (now < anchor) return { start: anchor, end: anchor + durationMs, live: false };

    const elapsedWeeks = Math.floor((now - anchor) / WEEK_MS);
    const currentStart = anchor + elapsedWeeks * WEEK_MS;
    const currentEnd = currentStart + durationMs;
    if (now < currentEnd) return { start: currentStart, end: currentEnd, live: true };

    const nextStart = currentStart + WEEK_MS;
    return { start: nextStart, end: nextStart + durationMs, live: false };
  };

  // House standard §4: western digits (0-9) always. Intl defaults ar-* to the
  // `arab` numbering system, so pin `latn` while keeping Arabic month/weekday names.
  const latn = (locale) => {
    const tag = String(locale || 'en-KW');
    if (!tag.startsWith('ar') || tag.includes('-u-nu-')) return tag;
    return `${tag}-u-nu-latn`;
  };

  const formatEventDate = (timestamp, locale) => new Intl.DateTimeFormat(latn(locale), {
    timeZone: KUWAIT_TIME_ZONE,
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    hour: 'numeric',
    minute: '2-digit'
  }).format(new Date(timestamp));

  document.querySelectorAll('[data-nabat-rare-drops]').forEach(async (section) => {
    const countdown = section.querySelector('[data-nabat-countdown]');
    if (!countdown) return;

    const anchor = Date.parse(countdown.dataset.startsAt || '');
    const durationHours = Number(countdown.dataset.durationHours || 2);
    const durationMs = durationHours * HOUR_MS;
    const schedule = countdown.dataset.schedule === 'weekly' ? 'weekly' : 'single';
    if (!Number.isFinite(anchor) || !Number.isFinite(durationMs) || durationMs <= 0) return;

    const timer = countdown.querySelector('[role="timer"]');
    const liveStatus = countdown.querySelector('[data-live-status]');
    const nextDate = countdown.querySelector('[data-next-date]');
    const fields = {
      days: countdown.querySelector('[data-days]'),
      hours: countdown.querySelector('[data-hours]'),
      minutes: countdown.querySelector('[data-minutes]'),
      seconds: countdown.querySelector('[data-seconds]')
    };
    if (!timer || !liveStatus || !nextDate || Object.values(fields).some((field) => !field)) return;

    const locale = countdown.dataset.locale || 'en-KW';
    const nextLabel = countdown.dataset.nextLabel || '';
    // The schedule is the only authority (2 Sep 2026): Liquid decides from the
    // weekly window, and this script only keeps the countdown ticking. When the
    // clock crosses into the window on an already-open page, it reloads once so
    // Liquid can render the products.
    const liquidAuthorized = countdown.dataset.authoritativeLive === 'true';
    const serverClockOffset = 0;
    const RELOAD_KEY = 'nabat-rare-reloaded';

    const authoritativeLive = liquidAuthorized;
    section.querySelectorAll('[data-rare-authorized-content]').forEach((element) => {
      element.hidden = !authoritativeLive;
    });
    countdown.hidden = false;

    let interval;
    const update = () => {
      const now = Date.now() + serverClockOffset;
      const eventWindow = resolveEventWindow(anchor, schedule, durationMs, now);

      if (schedule === 'single' && now >= eventWindow.end) {
        countdown.hidden = true;
        if (interval) window.clearInterval(interval);
        return;
      }

      if (eventWindow.live && !liquidAuthorized) {
        let reloaded = false;
        try { reloaded = window.sessionStorage.getItem(RELOAD_KEY) === '1'; } catch (_e) { /* storage blocked */ }
        if (!reloaded) {
          try { window.sessionStorage.setItem(RELOAD_KEY, '1'); } catch (_e) { /* storage blocked */ }
          window.location.reload();
          return;
        }
      }
      if (!eventWindow.live) {
        try { window.sessionStorage.removeItem(RELOAD_KEY); } catch (_e) { /* storage blocked */ }
      }

      if (eventWindow.live) {
        timer.hidden = true;
        nextDate.hidden = true;
        liveStatus.hidden = false;
        liveStatus.classList.toggle('is-live', authoritativeLive);
        liveStatus.textContent = authoritativeLive
          ? (countdown.dataset.liveLabel || '')
          : (countdown.dataset.closedLabel || '');
        return;
      }

      liveStatus.classList.remove('is-live');
      liveStatus.hidden = true;
      timer.hidden = false;
      nextDate.hidden = false;
      const formattedDate = formatEventDate(eventWindow.start, locale);
      nextDate.textContent = nextLabel ? `${nextLabel}: ${formattedDate}` : formattedDate;

      const totalSeconds = Math.max(0, Math.floor((eventWindow.start - now) / 1000));
      fields.days.textContent = pad(Math.floor(totalSeconds / 86400));
      fields.hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
      fields.minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      fields.seconds.textContent = pad(totalSeconds % 60);
    };

    update();
    if (!countdown.hidden) interval = window.setInterval(update, 1000);
  });
})();
